import {Button} from '@material-ui/core';
import {ModalState, showModal} from 'Core/ducks/modal';
import * as O from 'fp-ts/lib/Option';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Column from 'Shared/components/PagedView/Column';
import {withStringFilterProperties} from 'Shared/components/PagedView/Filter';
import PagedView from 'Shared/components/PagedView/PagedView';
import RequireScope from 'Shared/components/RequireScope';
import {Scope} from 'Shared/constants/Scope';
import {withValueChangedHook} from 'Shared/utilities/withValueChanged';
import {resendEmail} from 'Users/ducks/independentAgent';
import {changePreregisteredUsersFilter, getPreregisteredUsers} from 'Users/ducks/userAdministration';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';

export const PendingCustomerSupportRegistration = () => {
  const dispatch = useDispatch();
  const scopes = useSelector(selectUserScopes);
  const {selectedAgency} = useSelector((state: ReducerState) => state.user.profile);
  const encryptedIdentifier = O.isSome(selectedAgency) ? selectedAgency.value.encryptedIdentifier : undefined;

  const {preregisteredUsers, preregisteredUserFilter} = useSelector(
    (state: ReducerState) => state.user.userAdministration
  );

  useEffect(() => {
    dispatch(getPreregisteredUsers(preregisteredUserFilter, undefined, encryptedIdentifier));
  }, [dispatch, preregisteredUserFilter]);

  const changeFilter = withValueChangedHook(preregisteredUserFilter, changePreregisteredUsersFilter, dispatch);
  const filterProperties = {
    changeFilter,
    filterData: preregisteredUserFilter,
  };

  return (
    <PagedView
      pagedViewKey="pendingUserRegistration"
      loadMore={page => dispatch(getPreregisteredUsers(preregisteredUserFilter, page, encryptedIdentifier))}
      data={preregisteredUsers}
    >
      {columnProps => (
        <>
          <Column
            {...columnProps}
            title="First Name"
            filterProperties={withStringFilterProperties(filterProperties, 'firstName')}
            default
          >
            {registration => registration.firstName}
          </Column>
          <Column
            {...columnProps}
            title="Last Name"
            filterProperties={withStringFilterProperties(filterProperties, 'lastName')}
            default
          >
            {registration => registration.lastName}
          </Column>
          <Column
            {...columnProps}
            title="Email"
            filterProperties={withStringFilterProperties(filterProperties, 'email')}
            default
          >
            {registration => registration.email}
          </Column>
          <Column {...columnProps} isActions title="" default>
            {registration => (
              <>
                <RequireScope scopes={scopes} scope={Scope.SendRegistrationEmail}>
                  <Button
                    color="primary"
                    onClick={() => {
                      dispatch(resendEmail(registration.id, encryptedIdentifier));
                    }}
                  >
                    Resend Email
                  </Button>
                </RequireScope>
                {scopes.find(scope => scope.toString().includes(Scope.DeletePreregistrationUser.toString())) && (
                  <Button
                    color="primary"
                    onClick={() => {
                      dispatch(
                        showModal(
                          ModalState.DeletePendingRegistrationConfirmation({
                            id: registration.id,
                            filter: preregisteredUserFilter,
                            encryptedIdentifier,
                          })
                        )
                      );
                    }}
                  >
                    Delete
                  </Button>
                )}
              </>
            )}
          </Column>
        </>
      )}
    </PagedView>
  );
};

export default PendingCustomerSupportRegistration;
